"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMedicalTreatment = createMedicalTreatment;
const events_1 = require("../../../events");
const queries_1 = require("../queries");
const messages = {
    medicalTreatment: {
        id: "dashboard.medical_treatment",
        defaultMessage: "Gyógyszeres kezelés"
    },
    drugTypeName: {
        id: "dashboard.drug_type_name",
        defaultMessage: "Gyógyszer neve"
    },
    drugTypeDose: {
        id: "dashboard.drug_type_dose",
        defaultMessage: "Dózis"
    }
};
function createMedicalTreatment({ formatMessage }, { events }) {
    const event = (0, events_1.findLastEventByQuery)(events, queries_1.queries.medicalTreatment);
    if (event === undefined) {
        return undefined;
    }
    const { drugType } = event.value;
    if (drugType === undefined || drugType.length === 0) {
        return undefined;
    }
    const columns = [
        formatMessage(messages.drugTypeName),
        formatMessage(messages.drugTypeDose)
    ];
    const rows = drugType.map(({ drugTypeName, drugTypeDose }) => [
        drugTypeName,
        drugTypeDose
    ]);
    const { timestamp, sid, origin } = event;
    return {
        type: "table",
        label: formatMessage(messages.medicalTreatment),
        attachments: (0, events_1.mapEventsToAttachments)(event),
        columns,
        rows,
        timestamp,
        sid,
        origin
    };
}
